import React, { useCallback, useEffect, useMemo } from "react";
import { AutocompleteComponent } from "../../Controls";
import { ReskinningAutocomplete } from "../../V2";
import { GetAllUnitsForLeadOwner, getUnits } from "../../../Services";
import { useDebouncedAction } from "../../../Hooks/DebouncedAction";

const UnitsAutocomplete = ({
  propertyId,
  value,
  onChange,
  isSaleUnitType,
  forOwner,
  isNewLayout,
}) => {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const getUnitsSearchFunction = useMemo(
    () => (forOwner ? GetAllUnitsForLeadOwner : getUnits),
    [forOwner]
  );
  const getUnitsSearch = useCallback(
    useDebouncedAction(async (searchText) => {
      setLoading(true);
      const res = await getUnitsSearchFunction({
        pageIndex: 0,
        pageSize: 100,
        search: searchText,
        propertyId,
        isSaleUnitType,
      });
      if ("result" in res) {
        setData(res.result);
      }
      setLoading(false);
    }),
    [propertyId, isSaleUnitType]
  );
  useEffect(() => {
    if (propertyId) {
      getUnitsSearch();
    }
  }, [propertyId, getUnitsSearch]);

  useEffect(() => {
    onChange(null, null);
  }, [isSaleUnitType]);

  if (isNewLayout) {
    return (
      <ReskinningAutocomplete
        data={data}
        isLoading={loading}
        onInputChange={(_e, value) => getUnitsSearch(value)}
        displayLabel={(item) => item.unit?.unit_ref_no ?? ""}
        multiple={false}
        getOptionSelected={(item, value) => item.unitId === value.unitId}
        selectedValues={value}
        onChange={onChange}
        withoutSearchButton
      />
    );
  }

  return (
    <AutocompleteComponent
      data={data}
      isLoading={loading}
      onInputChange={(_e, value) => getUnitsSearch(value)}
      displayLabel={(item) => item.unit?.unit_ref_no ?? ""}
      multiple={false}
      getOptionSelected={(item, value) => item.unitId === value.unitId}
      selectedValues={value}
      onChange={onChange}
      withoutSearchButton
    />
  );
};
export default UnitsAutocomplete;
